export { DefaultWithQuote } from "./DefaultWithQuote";
